module.exports = __webpack_public_path__ + "img/app1.729b21ef.png";